import { AfterViewInit, Component, HostListener, Input, OnDestroy, OnInit } from '@angular/core';
import { Terminal, TerminalAction } from 'src/app/@core/domain/interfaces/terminal.interface';
import { StatusPageService } from '../../../services/status-page.service';
import { NbDialogRef, NbLayoutRulerService } from '@nebular/theme';
import { AnonymousPassageComponent } from './anonymous-passage/anonymous-passage.component';
import { ControlledPassageComponent } from './controlled-passage/controlled-passage.component';
import { TerminalStatusComponent } from './terminal-status/terminal-status.component';
import { AccessModeComponent } from './access-mode/access-mode.component';
import { IdentificationComponent } from './identification/identification.component';
import { TerminalScreenComponent } from './terminal-screen/terminal-screen.component';
import { TerminalsApiService } from '../../../../../@core/api/terminals-api.service';
import { TerminalEventsComponent } from './terminal-events/terminal-events.component';
import { LogService } from '../../../../../@core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-terminal-actions-dialog',
  templateUrl: './terminal-actions-dialog.component.html',
  styleUrls: ['./terminal-actions-dialog.component.scss'],
})
export class TerminalActionsDialogComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input()
  terminal!: Terminal;

  terminalSubscription$!: Subscription;

  activeComponent!: any;
  currentAction = '';
  filteredActions: TerminalAction[] = [];
  disableToggleClick = true;
  showContextualActions = true;
  activeClass = '';
  refresh = false;

  constructor(
    private statusPageService: StatusPageService,
    private terminalsApiService: TerminalsApiService,
    private layoutRuleService: NbLayoutRulerService,
    private logger: LogService,
    protected ref: NbDialogRef<TerminalActionsDialogComponent>
  ) {}

  @HostListener('window:resize', [])
  onResize(): void {
    this.getWindowSize();
  }

  ngOnInit(): void {
    this.statusPageService.triggerRefreshNotifications(false);
    this.statusPageService.refreshTerminalSummary.subscribe((status) => {
      if (status && this.terminal && this.terminal.id) {
        this.terminalSubscription$ = this.terminalsApiService
          .loadTerminalById(this.terminal.id)
          .subscribe((data) => {
            this.terminal = data;
            this.disableToggleClick = false;
            this.setAvailableActions();
          });
      }
    });
    this.getWindowSize();
    this.openTerminalAction('showTerminalEvents');
  }

  ngAfterViewInit() {
    this.terminalSubscription$ = this.terminalsApiService
      .loadTerminalById(this.terminal.id)
      .subscribe((data) => {
        this.terminal = data;
        this.disableToggleClick = false;
        this.setAvailableActions();
      });
  }

  getWindowSize() {
    this.layoutRuleService.getDimensions().subscribe((data) => {
      this.showContextualActions = data.clientWidth >= 1024;
    });
  }

  dismiss() {
    this.statusPageService.triggerRefreshNotifications(true);
    this.ref.close();
  }

  openTerminalAction(action: string) {
    this.currentAction = action;
    switch (action) {
      case 'grantAnonymousPassage':
        this.activeComponent = AnonymousPassageComponent;
        this.logger.info('Open dialog grantAnonymousPassage');
        break;
      case 'grantControlledPassage':
        this.activeComponent = ControlledPassageComponent;
        this.logger.info('Open dialog grantControlledPassage');
        break;
      case 'manageTerminalStatus':
        this.activeComponent = TerminalStatusComponent;
        this.logger.info('Open dialog manageTerminalStatus');
        break;
      case 'manageAccessMode':
        this.activeComponent = AccessModeComponent;
        this.logger.info('Open dialog manageAccessMode');
        break;
      case 'searchIdentification':
        this.activeComponent = IdentificationComponent;
        this.logger.info('Open dialog searchIdentification');
        break;
      case 'showTerminalScreen':
        this.activeComponent = TerminalScreenComponent;
        this.logger.info('Open dialog showTerminalScreen');
        break;
      case 'showTerminalEvents':
        this.activeComponent = TerminalEventsComponent;
        this.logger.info('Open dialog showTerminalEvents');
        break;
    }
  }

  onChangeComponent($event: string) {
    this.openTerminalAction($event);
  }

  getCssClass(currentAction: string) {
    if (currentAction === this.currentAction) {
      return 'active';
    }
    return '';
  }

  onPreventToggleClick($event: boolean) {
    this.disableToggleClick = true;
  }

  onActionCompleted($event: boolean) {
    this.refresh = false;
    this.terminalSubscription$ = this.terminalsApiService
      .loadTerminalById(this.terminal.id)
      .subscribe((data) => {
        this.terminal = data;
        this.refresh = true;
        this.disableToggleClick = false;
        this.setAvailableActions();
      });
  }

  ngOnDestroy(): void {
    this.terminalSubscription$.unsubscribe();
  }

  private setAvailableActions() {
    if (this.terminal.availableActions) {
      this.filteredActions = [];
      this.terminal.availableActions.forEach((action: TerminalAction) => {
        switch (action.type) {
          case 1:
          case 2:
          case 3:
          case 4:
          case 21:
          case 23:
          case 30:
            this.filteredActions.push(action);
            break;
        }
      });
      this.refresh = false;
    }
  }
}
